import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import Tooltip from 'rc-tooltip';
import General from '../../modules/General';
import OptionColumn from "../../components/general/OptionColumn";
class Templates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:true,
            isError:false,
            askCreate:false,
            askUpgrade:false,
            askDelete:false,
            followUpFor:false,
            columns:[],
            emails:[],
            currentTest:false,
            showDialog:false,
        }

        this.followup = this.followup.bind(this);
        this.rows = this.rows.bind(this);
        this.templateRow = this.templateRow.bind(this);
        this.duplicate = this.duplicate.bind(this);
        this.templateRows = this.templateRows.bind(this);
        this.newTemplate = this.newTemplate.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.update = this.update.bind(this);
    }

    newTemplate() {
        this.setState({isLoading:true});

        axios.post('/emails/template').then(res => {
            this.setState({isLoading:false});
            this.props.router.push(General.Link('/builder/email/'+res.data.id));
        });

    }

    handleSave() {
        this.update();
    }

    update() {
        axios.get(`/emails`)
            .then(res => {
                this.setState({
                    ...this.state,
                    'isError':false,
                    'isLoading':false,
                    'emails':res.data
                });
            })
            .catch(res => {
                this.setState({'isError':res.message});
            });
    }

    createFollowup() {
        this.setState({
            askCreate:false,
        });

        if(this.props.general.settings.PACKAGE_FOLLOWUP != '1') {
            this.setState({
                askUpgrade:true,
            });
        }else{
            this.setState({isLoading:true});
            axios.post('/emails/'+this.state.followUpFor+'/followup').then((res) => {
                this.setState({isLoading:false});
                this.props.router.push(General.Link('/builder/email/'+res.data.id));
            });
        }
    }

    duplicate(id) {
        this.setState({
            isLoading:true,
        });

        axios.post('/emails/'+id+'/duplicate').then((res) => {
            this.setState({isLoading:false});
            this.props.router.push(General.Link('/builder/email/'+res.data.id));
        });
    }

    followup(id) {
        this.setState({
            askCreate:true,
            followUpFor:id,
        });
    }

    placeholder() {
        return <span className="tag tag-default" style={{display:'inline-block',width:'35%'}}>&nbsp;</span>;
    }

    askDelete(id) {
        this.setState({askDelete:id});
    }

    delete(id) {
        this.setState({askDelete:false,isLoading:true});
        axios.delete('/emails/'+id).then(res => {
            axios.get(`/emails`)
                .then(res => {
                    this.setState({
                        'isError':false,
                        'isLoading':false,
                        'emails':res.data
                    });
                });
        });
    }

    rowOptions(email) {
        return (
            <div className="btn-group" role="group">
                {
                    email.type != 'TEMPLATE' ? <Tooltip placement="top" overlay={<span>Create followup</span>}>
                        <button onClick={() => this.followup(email.id)} className="btn btn-icon btn-default btn-outline"><i className="icon fa-level-up" aria-hidden="true"></i></button>
                    </Tooltip>:null
                }

                <Tooltip placement="top" overlay={<span>Edit e-mail</span>}>
                    <Link to={General.Link(`/builder/email/${email.id}`)} className="btn btn-icon btn-default btn-outline"><i className="icon wb-pencil" aria-hidden="true"></i></Link>
                </Tooltip>

                <Tooltip placement="top" overlay={<span>Duplicate e-mail</span>}>
                    <button onClick={() => this.duplicate(email.id)} className="btn btn-icon btn-default btn-outline"><i className="icon wb-copy" aria-hidden="true"></i></button>
                </Tooltip>

                <Tooltip placement="top" overlay={<span>Delete e-mail</span>}>
                    <button onClick={(e) => {this.askDelete(email.id)}} type="button" className="btn btn-icon btn-default btn-outline"><i className="icon wb-trash" aria-hidden="true"></i></button>
                </Tooltip>
            </div>
        );
    }

    templateRow(email) {

        return (
            <tr key={`email-${email.id}`}>
                <td>#{email.id}</td>
                <td style={{width:'80%','textAlign':'left'}}>
                    {email.subject}
                </td>

                <td>
                    {this.rowOptions(email)}
                </td>
            </tr>
        )


    }



    emailRow(email,followup = false) {
        let ret = [];

        let td_style = {};
        if(followup) {
            td_style.backgroundColor = '#fafafa';
        }

        ret.push(<tr key={`email-${email.id}`}>
            <td style={td_style} >#{email.id}</td>
            <td style={td_style}>
                <div style={{position:'relative'}}>
                    {followup ? <i className="icon fa-level-up" style={{position:'absolute','left':0,top:4,fontSize:'17px',transform:'scale(-1, 1)'}}></i>:null}
                    {email.subject}
                </div>
            </td>

            {this.state.columns.includes('t') ? <td style={td_style}>{email.description}</td>:null}
            {this.state.columns.includes('cs') ? <td style={td_style}>{email.clicked}</td>:null}
            {this.state.columns.includes('cr') ? <td style={td_style}>{email.clickRate}%</td>:null}
            {this.state.columns.includes('o') ? <td style={td_style}>{email.opened}</td>:null}
            {this.state.columns.includes('or') ? <td style={td_style}>{email.openRate}%</td>:null}
            {this.state.columns.includes('s') ? <td style={td_style}>{email.sent}</td>:null}
            {this.state.columns.includes('q') ? <td style={td_style}>{email.queued}</td>:null}
            {this.state.columns.includes('r') ? <td style={td_style}>{email.revenue}</td>:null}
            {this.state.columns.includes('c') ? <td style={td_style}>{email.converted}</td>:null}
            {this.state.columns.includes('cvr') ? <td style={td_style}>{email.rate}%</td>:null}

            <td style={td_style} className={`column-status s-${email.status}`}>
                <span>{email.status > 0 ? <i className="icon wb-check"></i>:<i className="icon wb-close"></i>}</span>
            </td>
            <td style={td_style}>
                {this.rowOptions(email)}
            </td>
        </tr>);

        for(let i in email.followup) {
            let rows = this.emailRow(email.followup[i],true);

            for(let r in rows) {
                ret.push(rows[r]);
            }
        }

        return ret;
    }

    rows() {

        let data = [];
        this.state.emails.map((email,i) => {
            if(email.type != 'TEMPLATE') {
                data.push(this.emailRow(email));
            }
        });

        if(data.length < 10) {
            let placeholder = this.placeholderRow((10-data.length),(this.state.columns.length+4));
            for(let i in placeholder) {
                data.push(placeholder[i]);
            }
        }

        return data;
    }

    templateRows() {

        let data = [];
        this.state.emails.map((email,i) => {
            if(email.type == 'TEMPLATE') {
                data.push(this.templateRow(email));
            }
        });

        if(data.length < 10) {
            let placeholder = this.placeholderRow((10-data.length),3);
            for(let i in placeholder) {
                data.push(placeholder[i]);
            }
        }

        return data;
    }

    placeholderRow(rows,cols) {
        let td = [];
        for(let i = 1;i<=cols;i++) {
            td.push(<td key={i}>{this.placeholder()}</td>);
        }

        let row = [];
        for(let i = 1;i<=rows;i++) {
            row.push(<tr key={i}>{td}</tr>);
        }

        return row;
    }

    componentWillMount() {
        this.update();
    }

    render() {
        if(this.state.isLoading) {
            return (
                <Loading error={this.state.isError} />
            );
        }

        if(this.state.emails.length == 0) {
            return (
                <div className="page-content">
                    <Helmet title="E-mails | Crall.io" />
                    <NoResult
                        header="No e-mails found"
                        body="You have not created a e-mail yet. Click the button to get started."
                        link="/builder/email/picker"
                        button="Create my first e-mail"
                    />

                </div>
            );
        }

        return (
            <div className="full-height">
                <div className="page-header">
                    <span className="page-title"><i className="icon fa-files-o"></i> Templates</span>
                    <div className="page-header-actions">
                        <div style={{marginRight:'10px'}} className="btn-group dropdown">
                            <button type="button" className="btn btn-dark dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                                <i className="icon fa-plus" style={{marginRight:'10px'}}></i> Create new
                            </button>
                            <div className="dropdown-menu dropdown-menu-bullet dropdown-menu-right" role="menu">
                                <a onClick={this.newTemplate} className="dropdown-item" href="javascript:void(0)" role="menuitem">Template</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="page-content">
                    <Helmet title="Templates | Crall.io" />

                    <OptionColumn title="Templates" cols={{'left':2,'right':10}} panel={false} description="List of all your custom e-mail templates">
                        <table className="table outline">
                            <tbody>
                            <tr>
                                <th>#</th>
                                <th style={{textAlign:'left'}}>Description</th>
                                <th>Actions</th>
                            </tr>
                            </tbody>
                            <tbody>
                            {this.templateRows()}
                            </tbody>
                        </table>
                    </OptionColumn>
                </div>
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


Templates = connect(mapStateToProps,mapDispatchToProps)(Templates);
export default Templates;


// WEBPACK FOOTER //
// ./containers/emails/templates.js